import { render } from "./main-news.vue?vue&type=template&id=76bdf3f4&bindings={}"
import script from "./main-news.vue?vue&type=script&lang=ts"
export * from "./main-news.vue?vue&type=script&lang=ts"

import "./main-news.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script